export default __webpack_public_path__ + "static/media/play.b6288b1b.svg";